// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__b_8Xv","resendInfoText":"OnGoingPaymentBox_resendInfoText__3w-2c"};